module.exports = __webpack_public_path__ + "static/media/B2Bjiaoyiguanlixitong.44c42992.png";